import GroupDetail from "../js/components/dashboard/GroupDetail.react";
export default GroupDetail;
